import { getNameInitials, toAbsoluteUrl } from "../../helpers";
import { useAuth, useStore } from "../../hooks";
import { useLayout } from "../../context";
import { SideMenu } from "./SideMenu";
import Skeleton from "react-loading-skeleton";
import { ChevronRight, Pencil } from "react-bootstrap-icons";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

type Props = {
  onChangeStore?: () => void;
  onLogout: () => void;
  isCollapsed: boolean;
};

export const Sidebar: React.FC<Props> = ({
  onChangeStore = () => {},
  onLogout,
  isCollapsed,
}) => {
  const { storeLocations, selectedStore, isLoyaltyActive } = useStore();
  const { customer, isLoggedIn, isGuest } = useAuth();
  const { setActiveModal } = useLayout();

  if (!selectedStore)
    return (
      <div className="p-4">
        <Skeleton height={160} className="mb-3" />
        <Skeleton count={2} />
        <Skeleton count={8} height={30} className="mt-2" />
      </div>
    );

  return (
    <>
      <div
        className={`sidebar-wrapper ${isCollapsed ? "collapsed" : "expanded"}`}
      >
        <div className="logo">
          <Link to={"/"} className="d-md-none">
            <img className="m-auto" src={storeLocations?.store_logo} alt="" />
          </Link>
          {!isCollapsed && (
            <h5 className="d-none d-lg-flex align-items-center">
              <span className="d-flex flex-row justify-content-center align-items-start">
                <FaMapMarkerAlt className="address_icon" />
                <span className="left_sidebar_address ms-1">
                  {" "}
                  {selectedStore?.store_address}
                </span>
              </span>
              {storeLocations && storeLocations?.locations.length > 1 && (
                <span
                  className="d-flex flex-row cursor-pointer ps-1"
                  onClick={onChangeStore}
                >
                  <Pencil size={12} />
                </span>
              )}
            </h5>
          )}

          {customer && !isCollapsed && (
            <div className="d-none left_menu_goal">
              {getNameInitials(customer.first_name + " " + customer.last_name)}
            </div>
          )}
        </div>

        <div
          className={`${!isLoyaltyActive || isLoggedIn ? "no-loyalty-card" : ""}`}
        >
          <SideMenu collapsed={isCollapsed} onLogout={onLogout} />
        </div>

        {!isCollapsed && isLoyaltyActive && (
          <>
            {(!isLoggedIn || isGuest) && (
              <div className="loyalty-points-card">
                <div className="loyalty-top">
                  <div className="gift-icon-wrap">
                    <img
                      src={toAbsoluteUrl("images/gift-icon.svg")}
                      alt="gift"
                    />
                  </div>

                  <div className="loyalty-content">
                    <span className="loyalty-label">Loyalty Points</span>
                  </div>
                </div>

                {!isLoggedIn && (
                  <button
                    className="signup-to-claim-btn"
                    onClick={() => setActiveModal("register")}
                  >
                    Sign Up To Claim
                    <ChevronRight size={16} />
                  </button>
                )}
              </div>
            )}
          </>
        )}

        {/* {!isCollapsed && isLoyaltyActive && Number(loyaltyPoints) > 0 && (
          <div className="loyalty-points-card">
            <div className="loyalty-top">
              <div className="gift-icon-wrap">
                <img src={toAbsoluteUrl("images/gift-icon.svg")} alt="gift" />
              </div>

              <div className="loyalty-content">
                <span className="loyalty-label">Loyalty Points</span>

                <h3 className="loyalty-points">
                  {loyaltyPoints}
                  <small>Pts</small>
                </h3>
              </div>
            </div>

            {!isLoggedIn && (
              <button
                className="signup-to-claim-btn"
                onClick={() => setActiveModal("register")}
              >
                Sign Up To Claim
                <ChevronRight size={16} />
              </button>
            )}
          </div>
        )} */}

        {/* Start */}
        {/* {!isCollapsed &&isLoyaltyActive && (
            <div className="col-md-12 loyalty-points-card mt-5">
              <div className='col-md-12 d-flex justify-content-between align-item-center'>
                <img src={toAbsoluteUrl("images/gift-icon.svg")} alt="" />
                <p> Loyalty Points
                  <span>{loyaltyPoints} <span className='points-text'>Pts</span></span>
                </p>
              </div>
              {(!isLoggedIn || isGuest) && <div className="col-md-12">
                <button className='signup-to-claim-btn' onClick={() => setActiveModal('register')}>SignUp To Claim</button>
              </div>}
            </div>
          )} */}
        {/* End */}
      </div>
    </>
  );
};
